<template>
  <DefaultLayout>
    <template #layout__header-contacts>
      <div class="mainPage__contacts">
        <div class="mainPage__contacts-item">
          <p>Группа ЭПК МСХ:</p>
          <a href="https://max.ru/join/EONRVXoszNpE1Hs3n1DH2O2yAaqi6MN3SUn9IhmwJpI">MAX</a>
        </div>
        <div class="mainPage__contacts-item">
          <p>Телефон:</p>
          <p>8 800 333-26-55</p>
        </div>
        <div class="mainPage__contacts-item">
          <p>Адрес электронной почты:</p>
          <p>gis.support@mcx.gov.ru</p>
        </div>
        <div class="mainPage__contacts-item">
          <p>Время работы по МСК:</p>
          <div class="mainPage__contacts-time">
            <p>Пн-чт: 09:00 - 18:00</p>
            <p>Пт: 09:00 - 16:45</p>
          </div>
        </div>
      </div>
    </template>

    <!-- <template #layout__header-info>
			<button class="mainPage__button">
				<svg width="20" height="20">
					<use xlink:href="sprite.svg#download"></use>
				</svg>
				<p>Скачать PDF</p>
			</button>
		</template> -->

    <template #layout__content>
      <div class="mainPage__content">
        <p>
          Необходимые участники для выполнения задачи:
          <span style="color: #d19b3f">пользователь с ролью ОМСУ/МКУ, МОУ (с правами на чтение и запись)</span>
        </p>
        <div v-for="(item, idx) in options" :key="idx">
          <EpkChapter
            :name="item.title"
            :icon="item.icon"
            :page="item.page"
          ></EpkChapter>
        </div>
      </div>
    </template>
  </DefaultLayout>
</template>

<script setup>
import EpkChapter from "@/components/EpkChapter/EpkChapter.vue";
import DefaultLayout from "../DefaultLayout/DefaultLayout.vue";

const options = [
  {
    title: "Похозяйственная книга",
    icon: "epk",
    page: "epk",
  },
  {
    title: "ЕПГУ",
    icon: "epgu",
    page: "epgu",
  },
  {
    title: "Реестр лицевых счетов",
    icon: "account",
    page: "account",
  },
  {
    title: "Карточки ЛПХ",
    icon: "lph",
    page: "lph",
  },
  {
    title: "Агрегированные данные",
    icon: "agg",
    page: "agg",
  },
];
</script>

<style scoped lang="scss">
@import "./MainPage.scss";
</style>
